// eslint-disable-next-line import/no-cycle
import { ComponentData, ComponentMetadata, ErrorConfigForm } from '@/types/automated-scenarios';
// eslint-disable-next-line import/no-cycle
import { Lang, UserState } from '@/composables/User';
// eslint-disable-next-line import/no-cycle
import { StringMap, TypeCampaignEnum } from '@/types';
// eslint-disable-next-line import/no-cycle
import { getLinkedOperators } from '@/composables/AutomatedScenarios';
import { i18n } from '@/i18n';
// eslint-disable-next-line import/no-cycle
import { asInt } from '@/helpers';
// eslint-disable-next-line import/no-cycle
import {
  checkIfTemplateOrRedirectContainsVoucher,
  getTemplateAndRedirect, reusePreviousCouponValues, voucherMethodsValues, voucherTypeValues,
} from '@/composables/automated-scenarios/AutomatedScenariosSendingChannel';
import {
  between, integer, maxLength, minLength, requiredIf,
} from '@vuelidate/validators';
// eslint-disable-next-line import/no-cycle
import { localizedTextInputValidator } from '@/helpers/CustomValidator';
import useVuelidate from '@vuelidate/core';
// eslint-disable-next-line import/no-cycle
import { GetShopsConfigurationList, SaveShopsConfiguration } from '@/composables/shop/ShopsConfiguration';
import { GetWhatsappValidationStatus, SubmitWhatsappValidation } from '@/composables/services/Whatsapp';

let translation: any;
(async () => {
  translation = await i18n;
})();

export interface ActionSendWhatsappData {
  template_display_selector_id: number | null;
  reuse_a_previous_coupon: number;
  display_popup_on_site: number;
  template_display_reduction_method: number;
  template_display_reduction_descript: StringMap;
  template_display_reduction_type: number;
  template_display_reduction_identifiant: string;
  template_display_reduction_amount: number;
  template_display_reduction_duplicate: string;
  template_display_reduction_minorderamount: number;
  template_display_reduction_validtime: number;
  template_display_reduction_prefix: string;
  template_display_message_langs: string;
  template_validation_status: string;
  enabled_operator: number;
  [key: string]: any;
}

export enum ActionSendWhatsappValidationStatusEnum {
  NOT_SUBMITTED = 'not_submitted',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  ERROR = 'error'
}

const ActionSendWhatsappMetadata: ComponentMetadata<ActionSendWhatsappData> = {
  Meta: {
    kind: 'action',
    id: 'boxsendwhatsapp',
    label: 'Envoyer un message Whatsapp',
    icon: 'fa-comment-alt-dots',
    hasConfiguration: true,
    incompatibilities: {
      automation: {
        next_operators: [
          'boxabandonpanier', 'boxsitepasstime', 'boxquitsite',
          'boxperiodiclaunching', 'boxscrollpage', 'boxstatuscommand',
          'boxcustomjs', 'registeronsite', 'subscribetonewsletter',
          'boxsendwhatsapp', 'boxdisplayfreepopup', 'boxdisplayfreemodel',
          'boxvisitpage',
        ],
      },
      bulk: {
        next_operators: [
          'boxabandonpanier', 'boxsitepasstime', 'boxquitsite',
          'boxperiodiclaunching', 'boxscrollpage', 'boxstatuscommand',
          'boxcustomjs', 'registeronsite', 'subscribetonewsletter',
          'boxsendwhatsapp', 'boxdisplayfreepopup', 'boxdisplayfreemodel',
          'boxvisitpage', 'boxchoosebulklist', 'boxaudiencesetup',
        ],
      },
    },
    component: 'ActionSendWhatsapp',
    availableInCampaign: [TypeCampaignEnum.AUTOMATION, TypeCampaignEnum.BULK],
  },
  Create(data: ActionSendWhatsappData = {
    template_display_selector_id: null,
    reuse_a_previous_coupon: 0,
    display_popup_on_site: 0,
    template_display_reduction_method: 3,
    template_display_reduction_descript: {},
    template_display_reduction_type: 1,
    template_display_reduction_identifiant: '',
    template_display_reduction_amount: 0,
    template_display_reduction_duplicate: '',
    template_display_reduction_minorderamount: 0,
    template_display_reduction_validtime: 7,
    template_display_reduction_prefix: '',
    template_display_message_langs: '',
    template_validation_status: ActionSendWhatsappValidationStatusEnum.NOT_SUBMITTED,
    enabled_operator: 0,
  }): ComponentData<ActionSendWhatsappData> {
    const formattedData = data;
    const languages: string[] = UserState.activeShop?.langs.map((language: Lang) => language.id) ?? [];
    formattedData.template_display_message_langs = JSON.stringify(languages);

    return {
      id: 'boxsendwhatsapp',
      form_name: 'boxsendwhatsapp',
      logo_box: 'fa-comment',
      ...formattedData,
    };
  },
  async Validate(data: ActionSendWhatsappData): Promise<ErrorConfigForm> {
    //         required: voucherTemplateValidator(data, 'method'),
    let mustConfigVoucher = false;
    if (data.template_display_selector_id && data.template_display_selector_id > 0) {
      const idTemplate = asInt(data.template_display_selector_id);
      let templatesContainsVoucher = false;
      const listTemplate = await getTemplateAndRedirect(UserState.activeShop?.id ?? 0, idTemplate);
      if (listTemplate !== null) {
        templatesContainsVoucher = checkIfTemplateOrRedirectContainsVoucher(listTemplate);
      }
      if (templatesContainsVoucher && data.reuse_a_previous_coupon === reusePreviousCouponValues.CONFIGURE_NEW_VOUCHER) {
        mustConfigVoucher = true;
      }
    }

    const rules: any = {
      template_display_reduction_method: {
        required: mustConfigVoucher,
      },
      template_display_reduction_descript: {
        required: false,
      },
      template_display_reduction_type: {
        required: mustConfigVoucher,
      },
      template_display_reduction_amount: {
        required: requiredIf(() => mustConfigVoucher && [voucherTypeValues.PERCENTAGE, voucherTypeValues.AMOUNT].includes(data.template_display_reduction_type)),
        integer,
      },
      template_display_reduction_minorderamount: {
        required: requiredIf(() => mustConfigVoucher && data.template_display_reduction_method === voucherMethodsValues.AUTOMATIC),
        between: between(0, 10000000),
      },
      template_display_reduction_prefix: {
        minLength: minLength(2),
        maxLength: maxLength(32),
      },
    };

    // template_display_reduction_identifiant
    if (mustConfigVoucher && data.template_display_reduction_method === voucherMethodsValues.MANUAL) {
      rules.template_display_reduction_identifiant = {
        required: true,
        minLength: minLength(2),
        maxLength: maxLength(45),
      };
    }

    if (mustConfigVoucher && data.template_display_reduction_method === voucherMethodsValues.AUTOMATIC && data.template_display_reduction_type === voucherTypeValues.DUPLICATED) {
      rules.template_display_reduction_duplicate = {
        required: true,
        minLength: minLength(2),
        maxLength: maxLength(45),
      };
    }

    if (mustConfigVoucher && data.template_display_reduction_method === voucherMethodsValues.AUTOMATIC) {
      rules.template_display_reduction_validtime = {
        required: true,
        between: between(1, 182),
      };
    }

    const v$ = useVuelidate(rules, data);
    const success = await v$.value.$validate();

    return {
      success,
      validate: v$,
    };
  },
  Outputs(data: ActionSendWhatsappData): number {
    return 1;
  },
  CanBeDeleted(operatorId: string): boolean | string {
    const canI = getLinkedOperators(operatorId);
    if (canI.length) {
      const listBoxes = canI.join(', ');
      return translation.global.t('automatedScenarios.box_dialog.delete_operator.warning_linked_box', { boxes: listBoxes });
    }
    return true;
  },
  Label(data: ActionSendWhatsappData): string {
    return 'Envoyer un message Whatsapp';
  },
  async Callback(data: ActionSendWhatsappData, skipValidation?: boolean): Promise<ActionSendWhatsappData> {
    // Auto submit whatsapp template for validation
    if (!skipValidation) {
      try {
        const response = await SubmitWhatsappValidation(UserState.activeShop?.id ?? 0, data);

        if (response.success && response.data && response.data.template) {
          const { status } = response.data.template;

          // Update validation status based on response
          switch (status) {
            case 'APPROVED':
              // eslint-disable-next-line no-param-reassign
              data.template_validation_status = ActionSendWhatsappValidationStatusEnum.APPROVED;
              break;
            case 'PENDING':
              // eslint-disable-next-line no-param-reassign
              data.template_validation_status = ActionSendWhatsappValidationStatusEnum.PENDING;
              // Force enabled_operator to false when pending
              // eslint-disable-next-line no-param-reassign
              data.enabled_operator = 0;
              break;
            case 'REJECTED':
            case 'UNKNOWN':
              // eslint-disable-next-line no-param-reassign
              data.template_validation_status = ActionSendWhatsappValidationStatusEnum.REJECTED;
              // Force enabled_operator to false when rejected or unknown
              // eslint-disable-next-line no-param-reassign
              data.enabled_operator = 0;
              break;
            default:
              // eslint-disable-next-line no-param-reassign
              data.template_validation_status = ActionSendWhatsappValidationStatusEnum.PENDING;
              // eslint-disable-next-line no-param-reassign
              data.enabled_operator = 0;
          }
        } else {
          // eslint-disable-next-line no-param-reassign
          data.template_validation_status = ActionSendWhatsappValidationStatusEnum.ERROR;
        }
      } catch (error) {
        // eslint-disable-next-line no-param-reassign
        data.template_validation_status = ActionSendWhatsappValidationStatusEnum.ERROR;
      }
    }

    return data;
  },
  async GetWhatsappValidationStatus(data: ActionSendWhatsappData): Promise<any> {
    try {
      const response = await GetWhatsappValidationStatus(UserState.activeShop?.id ?? 0, data.template_display_selector_id?.toString() ?? '');

      if (response.success && response.template) {
        const { status } = response.template;

        // Update validation status based on response
        switch (status) {
          case 'APPROVED':
            // eslint-disable-next-line no-param-reassign
            data.template_validation_status = ActionSendWhatsappValidationStatusEnum.APPROVED;
            break;
          case 'PENDING':
            // eslint-disable-next-line no-param-reassign
            data.template_validation_status = ActionSendWhatsappValidationStatusEnum.PENDING;
            // Force enabled_operator to false when pending
            // eslint-disable-next-line no-param-reassign
            data.enabled_operator = 0;
            break;
          case 'REJECTED':
          case 'UNKNOWN':
            // eslint-disable-next-line no-param-reassign
            data.template_validation_status = ActionSendWhatsappValidationStatusEnum.REJECTED;
            // Force enabled_operator to false when rejected or unknown
            // eslint-disable-next-line no-param-reassign
            data.enabled_operator = 0;
            break;
          default:
            // eslint-disable-next-line no-param-reassign
            data.template_validation_status = ActionSendWhatsappValidationStatusEnum.PENDING;
            // eslint-disable-next-line no-param-reassign
            data.enabled_operator = 0;
        }

        return data.template_validation_status;
      }
      // eslint-disable-next-line no-param-reassign
      data.template_validation_status = ActionSendWhatsappValidationStatusEnum.ERROR;
      return data.template_validation_status;
    } catch (error) {
      // eslint-disable-next-line no-param-reassign
      data.template_validation_status = ActionSendWhatsappValidationStatusEnum.ERROR;
      return data.template_validation_status;
    }
  },
  async ToggleEnabledOperator(data: ActionSendWhatsappData): Promise<boolean> {
    return true;
  },
} as ComponentMetadata<ActionSendWhatsappData>;

export default ActionSendWhatsappMetadata;
